/*
 * @Author: Zhouqi
 * @Date: 2026-02-05 14:05:51
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-02-06 10:36:04
 */
import { merge } from 'lodash';

import { FormConfigItem } from '@/components/ModelForm/types';
import { AIFunction } from '@/utils/const';

export const getBasePromptConfig = (
  source: AIFunction,
  config?: Partial<FormConfigItem>,
) =>
  merge(
    {
      type: 'prompt',
      label: 'Prompt',
      key: 'prompt',
      required: true,
      config: {
        maxLength: 2000,
        trackSource: source, // 声明式埋点
      },
    },
    config,
  );
